module.exports = __webpack_public_path__ + "img/add.30169ee1.png";